import { useCallback, useState, useEffect } from 'react';
import find from 'lodash/find';

import { useGroups } from 'modules/groups/hooks';

export default function useGroupSelector({ courseId }) {
  const { groups, loading } = useGroups({ courseId });

  const [selectedGroup, setSelectedGroup] = useState();

  const onSelectGroup = useCallback(
    (selectedGroupId) => {
      const group = find(groups, { _id: selectedGroupId });
      setSelectedGroup(group);
    },
    [groups]
  );

  useEffect(() => {
    const [firstGroup] = groups;
    if (firstGroup && !selectedGroup) {
      onSelectGroup(firstGroup._id);
    }
  }, [groups, selectedGroup, onSelectGroup]);

  return {
    selectedGroup,
    props: {
      groups,
      loading,
      selectedGroupId: selectedGroup?._id,
      onSelectGroup,
    },
  };
}
